import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import { create_stock_batch as _create_stock_batch, get_company_list as _get_company_list, out_stock_batch as _out_stock_batch, get_stock_list as _get_stock_list, get_sn, get_stock_operation as _get_stock_operation, get_stock_operation_record as _get_stock_operation_record, undo_stock_operation as _undo_stock_operation, update_stock_operation as _update_stock_operation, batch_create_isp_of_cstep } from "../../services/MI/MI2001S";
import { get_device_model as _get_device_model, get_cpe_template as _get_cpe_template, get_agency_list as _get_agency_list, all_company_update, cstep_device_changed } from "../../services/Company/companyS";
import { BossMessage } from "../../components/Common/BossMessages";
import { get_isp_dict as _get_isp_dict } from "../../services/CI/CI1401S";
import { get_os_version as _get_os_version } from "../../services/BI/BI0001S";
export default {
  namespace: "mi2001Info",
  state: {
    dataSource: [{
      cpeTemplateList: []
    }],
    dataSourceScan: [{}],
    companyList: [],
    agencyList: [],
    stockOperation: [],
    StockInNumberDataSource: [],
    deviceModelList: [],
    batchAdd: [],
    key: 0,
    snArr: [],
    inSnArr: [],
    cpeTemplateList: [],
    ispList: [],
    versionList: []
  },
  effects: {
    get_device_model: function get_device_model(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(_get_device_model, payload);
            case 2:
              backData = _context.sent;
              _context.next = 5;
              return put({
                type: "update",
                payload: {
                  deviceModelList: backData.result
                }
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    update_stock_operation: function update_stock_operation(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(_update_stock_operation, payload.update);
            case 2:
              backData = _context2.sent;
              if (backData.success) {
                BossMessage(true, "Successfully modified");
              } else {
                BossMessage(false, "Modification failed" + backData.result);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    undo_stock_operation: function undo_stock_operation(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(_undo_stock_operation, payload.id);
            case 2:
              backData = _context3.sent;
              if (!backData.success) {
                _context3.next = 12;
                break;
              }
              BossMessage(true, "Revoked successfully");
              if (!payload.company_id) {
                _context3.next = 8;
                break;
              }
              _context3.next = 8;
              return call(all_company_update, {
                company_id: payload.company_id
              });
            case 8:
              _context3.next = 10;
              return put({
                type: "get_stock_operation",
                payload: payload.init
              });
            case 10:
              _context3.next = 13;
              break;
            case 12:
              BossMessage(false, "Revoke failed" + backData.result);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    get_stock_operation_record: function get_stock_operation_record(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return call(_get_stock_operation_record, payload);
            case 2:
              backData = _context4.sent;
              _context4.next = 5;
              return put({
                type: "update",
                payload: {
                  StockInNumberDataSource: backData.result
                }
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    get_stock_operation: function get_stock_operation(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(_get_stock_operation, payload);
            case 2:
              backData = _context5.sent;
              if (!(backData.result && Array.isArray(backData.result))) {
                _context5.next = 8;
                break;
              }
              _context5.next = 6;
              return put({
                type: "update",
                payload: {
                  stockOperation: backData.result
                }
              });
            case 6:
              _context5.next = 10;
              break;
            case 8:
              _context5.next = 10;
              return put({
                type: "update",
                payload: {
                  stockOperation: []
                }
              });
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    create_stock_batch: function create_stock_batch(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put,
        select = _ref12.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(_create_stock_batch, payload.init);
            case 2:
              backData = _context6.sent;
              if (!backData.success) {
                _context6.next = 10;
                break;
              }
              BossMessage(true, "Received successfully");
              payload.vm.props.cancel();
              _context6.next = 8;
              return put({
                type: "get_stock_operation",
                payload: payload.select
              });
            case 8:
              _context6.next = 11;
              break;
            case 10:
              BossMessage(false, "Warehousing failed" + backData.result);
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    out_stock_batch: function out_stock_batch(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put,
        select = _ref14.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData, backData2, msg;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return call(_out_stock_batch, payload.init);
            case 2:
              backData = _context7.sent;
              if (!backData.success) {
                _context7.next = 19;
                break;
              }
              BossMessage(true, "Delivery successful");
              _context7.next = 7;
              return call(all_company_update, {
                company_id: payload.init && payload.init.company_id ? payload.init.company_id : ''
              });
            case 7:
              if (!(payload.init.device_type === 'CSTEP')) {
                _context7.next = 14;
                break;
              }
              _context7.next = 10;
              return call(batch_create_isp_of_cstep, payload.ispdata);
            case 10:
              backData2 = _context7.sent;
              if (!backData2.success) {
                BossMessage(false, "ISP setup failed" + backData2.result);
              }
              _context7.next = 14;
              return call(cstep_device_changed, {
                sn: payload.init.stocks[0] && payload.init.stocks[0].sn ? payload.init.stocks[0].sn : ''
              });
            case 14:
              payload.cancel();
              _context7.next = 17;
              return put({
                type: "get_stock_operation",
                payload: payload.select
              });
            case 17:
              _context7.next = 21;
              break;
            case 19:
              msg = backData.result && backData.result.indexOf("'version' cannot be null") > -1 ? "The basic version of the enterprise is not set" : backData.result;
              BossMessage(false, "Outbound failed:" + msg);
            case 21:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    // * get_stock_list({payload}, {call, put,select}) {
    //     let dataSource=yield select(state=>state.mi2001Info.dataSource);
    //     let snArr=yield select(state=>state.mi2001Info.snArr);
    //     let key = yield select(state=>state.mi2001Info.key);
    //     let backData=yield call(get_stock_list,payload.hard_sn);
    //     const backData2=yield call(get_sn,payload.get_sn);
    //     if(backData.result[0]){
    //         backData.result[0].sn=backData2.result
    //         backData.result[0].key=key
    //         dataSource.splice(dataSource.length-1,1,backData.result[0]);
    //         //push唯一标识符key
    //         dataSource.push({key:key+1})
    //     }
    //     if(backData.message==="success"){
    //         console.log(backData2)
    //         snArr.push(backData.result[0].hard_sn)
    //         yield put({
    //             type:"update",
    //             payload:{
    //                 dataSource:dataSource,
    //                 key:key+1,
    //                 snArr:snArr
    //             }
    //         })
    //     }else{
    //         BossMessage(false, backData.message);
    //     }
    // },
    addDataSource: function addDataSource(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put,
        select = _ref16.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var dataSourceScan, inSnArr, key, obj;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return select(function (state) {
                return state.mi2001Info.dataSourceScan;
              });
            case 2:
              dataSourceScan = _context8.sent;
              _context8.next = 5;
              return select(function (state) {
                return state.mi2001Info.inSnArr;
              });
            case 5:
              inSnArr = _context8.sent;
              _context8.next = 8;
              return select(function (state) {
                return state.mi2001Info.key;
              });
            case 8:
              key = _context8.sent;
              obj = payload.Object;
              obj.key = key;
              dataSourceScan.splice(dataSourceScan.length - 1, 1, obj);
              dataSourceScan.push({
                key: key + 1,
                model: payload.Object.model,
                name: payload.Object.name,
                remark: payload.Object.remark,
                lot_no: payload.Object.lot_no
              });
              inSnArr.push(obj.hard_sn);
              _context8.next = 16;
              return put({
                type: "update",
                payload: {
                  dataSourceScan: dataSourceScan,
                  key: key + 1,
                  inSnArr: inSnArr
                }
              });
            case 16:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    },
    batchAddDataSource: function batchAddDataSource(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put,
        select = _ref18.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var batchAdd, obj, i, key;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return select(function (state) {
                return state.mi2001Info.batchAdd;
              });
            case 2:
              batchAdd = _context9.sent;
              obj = payload.Object;
              i = 0;
            case 5:
              if (!(i < obj.length)) {
                _context9.next = 16;
                break;
              }
              _context9.next = 8;
              return select(function (state) {
                return state.mi2001Info.key;
              });
            case 8:
              key = _context9.sent;
              obj[i].key = key;
              batchAdd.push(obj[i]);
              _context9.next = 13;
              return put({
                type: "update",
                payload: {
                  key: key + 1
                }
              });
            case 13:
              i++;
              _context9.next = 5;
              break;
            case 16:
              _context9.next = 18;
              return put({
                type: "update",
                payload: {
                  dataSourceScan: batchAdd
                }
              });
            case 18:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      })();
    },
    deleteDataSource: function deleteDataSource(_ref19, _ref20) {
      var payload = _ref19.payload;
      var call = _ref20.call,
        put = _ref20.put,
        select = _ref20.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var dataSourceScan, inSnArr, arr, b, result, resultSn;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return select(function (state) {
                return state.mi2001Info.dataSourceScan;
              });
            case 2:
              dataSourceScan = _context10.sent;
              _context10.next = 5;
              return select(function (state) {
                return state.mi2001Info.inSnArr;
              });
            case 5:
              inSnArr = _context10.sent;
              arr = payload.deleteIds;
              b = arr.join(",");
              result = dataSourceScan.map(function (item, index) {
                if (b.indexOf(index) < 0) {
                  return item;
                }
              }).filter(function (item) {
                return item !== undefined;
              });
              resultSn = inSnArr.map(function (item, index) {
                if (b.indexOf(index) < 0) {
                  return item;
                }
              }).filter(function (item) {
                return item !== undefined;
              });
              if (result.length === 0) {
                result = [{}];
              }
              _context10.next = 13;
              return put({
                type: "update",
                payload: {
                  dataSourceScan: result,
                  inSnArr: resultSn
                }
              });
            case 13:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })();
    },
    closeDataSourceScan: function closeDataSourceScan(_ref21, _ref22) {
      var payload = _ref21.payload;
      var call = _ref22.call,
        put = _ref22.put,
        select = _ref22.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return put({
                type: "update",
                payload: {
                  dataSourceScan: [{}],
                  inSnArr: [],
                  batchAdd: []
                }
              });
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      })();
    },
    closeStockOut: function closeStockOut(_ref23, _ref24) {
      var payload = _ref23.payload;
      var call = _ref24.call,
        put = _ref24.put,
        select = _ref24.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return put({
                type: "update",
                payload: {
                  //dataSourceScan:[{}],
                  snArr: []
                }
              });
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      })();
    },
    //删除判断最后一行
    deleteOutDataSource: function deleteOutDataSource(_ref25, _ref26) {
      var payload = _ref25.payload;
      var call = _ref26.call,
        put = _ref26.put,
        select = _ref26.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var dataSource, key, snArr, arr, b, result, resultSn;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return select(function (state) {
                return state.mi2001Info.dataSource;
              });
            case 2:
              dataSource = _context13.sent;
              _context13.next = 5;
              return select(function (state) {
                return state.mi2001Info.key;
              });
            case 5:
              key = _context13.sent;
              _context13.next = 8;
              return select(function (state) {
                return state.mi2001Info.snArr;
              });
            case 8:
              snArr = _context13.sent;
              arr = payload.deleteIds;
              b = arr.join(",");
              result = dataSource.map(function (item, index) {
                if (b.indexOf(index) < 0) {
                  return item;
                }
              }).filter(function (item) {
                return item !== undefined;
              }); //如果删除最后一行，将会重新添加一行
              if (!(b.indexOf(dataSource.length - 1) >= 0)) {
                _context13.next = 16;
                break;
              }
              result.push({
                key: key + 1
              });
              _context13.next = 16;
              return put({
                type: "update",
                payload: {
                  key: key + 1
                }
              });
            case 16:
              resultSn = snArr.map(function (item, index) {
                if (b.indexOf(index) < 0) {
                  return item;
                }
              }).filter(function (item) {
                return item !== undefined;
              }); // if(result.length===0){
              //     result=[{}]
              // }
              _context13.next = 19;
              return put({
                type: "update",
                payload: {
                  dataSource: result,
                  snArr: resultSn
                }
              });
            case 19:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })();
    },
    //删除不判断最后一行
    // *submitDeleteOutDataSource({payload},{call,put,select}){
    //     let dataSource=yield select(state=>state.mi2001Info.dataSource);
    //     //判断是否重复
    //     let snArr=yield select(state=>state.mi2001Info.snArr);
    //     let arr = payload.deleteIds
    //     console.log(arr)
    //     let b = arr.join(",");
    //     let result=dataSource.map((item,index)=>{
    //         if(b.indexOf(index)<0){
    //             return item
    //         }
    //     }).filter((item)=>{
    //         return item!==undefined
    //     });
    //     let resultSn=snArr.map((item,index)=>{
    //         if(b.indexOf(index)<0){
    //             return item
    //         }
    //     }).filter((item)=>{
    //         return item!==undefined
    //     });
    //     if(result.length===0){
    //         result=[{}]
    //     }
    //         yield put({
    //             type:"update",
    //             payload:{
    //                 dataSource:result,
    //                 snArr:resultSn
    //             }
    //     })
    // },
    get_company_list: function get_company_list(_ref27, _ref28) {
      var payload = _ref27.payload;
      var call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context14.sent;
              _context14.next = 5;
              return put({
                type: "update",
                payload: {
                  companyList: backData.result
                }
              });
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      })();
    },
    get_agency_list: function get_agency_list(_ref29, _ref30) {
      var payload = _ref29.payload;
      var call = _ref30.call,
        put = _ref30.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!(payload.company_id && payload.type)) {
                _context15.next = 9;
                break;
              }
              _context15.next = 3;
              return call(_get_agency_list, payload);
            case 3:
              backData = _context15.sent;
              if (!backData.result) {
                _context15.next = 7;
                break;
              }
              _context15.next = 7;
              return put({
                type: "update",
                payload: {
                  agencyList: backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 7:
              _context15.next = 11;
              break;
            case 9:
              _context15.next = 11;
              return put({
                type: "update",
                payload: {
                  agencyList: []
                }
              });
            case 11:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      })();
    },
    get_stock_list: function get_stock_list(_ref31, _ref32) {
      var payload = _ref31.payload;
      var call = _ref32.call,
        put = _ref32.put,
        select = _ref32.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var dataSource, snArr, key, backData, backData2, backData3;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return select(function (state) {
                return state.mi2001Info.dataSource;
              });
            case 2:
              dataSource = _context16.sent;
              _context16.next = 5;
              return select(function (state) {
                return state.mi2001Info.snArr;
              });
            case 5:
              snArr = _context16.sent;
              _context16.next = 8;
              return select(function (state) {
                return state.mi2001Info.key;
              });
            case 8:
              key = _context16.sent;
              _context16.next = 11;
              return call(_get_stock_list, payload.hard_sn);
            case 11:
              backData = _context16.sent;
              if (!(backData.message === "success")) {
                _context16.next = 20;
                break;
              }
              _context16.next = 15;
              return call(get_sn, {
                os: payload.os,
                model: backData.result[0].model
              });
            case 15:
              backData2 = _context16.sent;
              if (!payload.company_id) {
                _context16.next = 20;
                break;
              }
              _context16.next = 19;
              return call(_get_cpe_template, {
                company_id: payload.company_id,
                model: backData.result[0].model
              });
            case 19:
              backData3 = _context16.sent;
            case 20:
              if (backData.result[0]) {
                backData.result[0].sn = backData2.result;
                backData.result[0].key = key;
                backData.result[0].disabled = true;
                backData.result[0].cpeTemplateList = backData3 && backData3.result ? backData3.result : [];
                dataSource.splice(dataSource.length - 1, 1, backData.result[0]); //push唯一标识符key
                dataSource.push({
                  key: key + 1,
                  disabled: false,
                  cpeTemplateList: []
                });
              }
              if (!(backData.message === "success")) {
                _context16.next = 27;
                break;
              }
              snArr.push(backData.result[0].hard_sn);
              _context16.next = 25;
              return put({
                type: "update",
                payload: {
                  dataSource: dataSource,
                  key: key + 1,
                  snArr: snArr
                }
              });
            case 25:
              _context16.next = 28;
              break;
            case 27:
              BossMessage(false, backData.message);
            case 28:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      })();
    },
    addOutDataSource: function addOutDataSource(_ref33, _ref34) {
      var payload = _ref33.payload;
      var call = _ref34.call,
        put = _ref34.put,
        select = _ref34.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var obj;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              obj = payload.Object;
              _context17.next = 3;
              return put({
                type: "update",
                payload: {
                  dataSource: obj
                }
              });
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      })();
    },
    get_cpe_template: function get_cpe_template(_ref35, _ref36) {
      var payload = _ref35.payload;
      var call = _ref36.call,
        put = _ref36.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return call(_get_cpe_template, payload);
            case 2:
              backData = _context18.sent;
              _context18.next = 5;
              return put({
                type: "update",
                payload: {
                  cpeTemplateList: backData.result
                }
              });
            case 5:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      })();
    },
    get_isp_dict: function get_isp_dict(_ref37, _ref38) {
      var payload = _ref37.payload;
      var call = _ref38.call,
        put = _ref38.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return call(_get_isp_dict, payload);
            case 2:
              backData = _context19.sent;
              _context19.next = 5;
              return put({
                type: "update",
                payload: {
                  ispList: backData.result
                }
              });
            case 5:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      })();
    },
    get_os_version: function get_os_version(_ref39, _ref40) {
      var payload = _ref39.payload;
      var call = _ref40.call,
        put = _ref40.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return call(_get_os_version, payload);
            case 2:
              backData = _context20.sent;
              _context20.next = 5;
              return put({
                type: "update",
                payload: {
                  versionList: backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};